import React, { useEffect, useRef, useState } from 'react';
import { ConstructorEventUpdateSQLStatus } from "../../../Event/event";
const EstimateTotal = () => {
  const [prices, setPrices] = useState([]);
  const [estimate, setEstimate] = useState('');
  const [feedback, setFeedback] = useState('');
  const [feedbackClass, setFeedbackClass] = useState('');
  const [showNew, setShowNew] = useState(false);
  const inputRef = useRef(null);

  const generatePrices = () => {
    const randomPrices = Array.from({ length: 3 }, () =>
      parseFloat((Math.random() * 9 + 1).toFixed(2))
    );
    setPrices(randomPrices);
    setEstimate('');
    setFeedback('');
    setFeedbackClass('');
    setShowNew(false);
    setTimeout(() => inputRef.current?.focus(), 100);
  };

  const calculateEstimate = () => {
    return prices.reduce((acc, val) => acc + Math.round(val), 0);
  };

  const checkEstimate = () => {
    const userNum = parseInt(estimate);
    if (isNaN(userNum)) {
      setFeedback('Please enter a number.');
      setFeedbackClass('incorrect');
      return;
    }

    const correctEstimate = calculateEstimate();
    if (userNum === correctEstimate) {
                  const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
      setFeedback(`Great job! The estimated total is $${correctEstimate}. 🎉`);
      setFeedbackClass('correct');

      setShowNew(true);
    } else {
      setFeedback('Oops, that’s not quite right. Try again!');
      setFeedbackClass('incorrect');
    }
  };

  useEffect(() => {
    generatePrices();
  }, []);

  const styles = {
    body: {
      fontFamily: "'Quicksand', sans-serif",
      margin: 0,
      padding: '1rem',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f9f7f1, #a9d6e5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      userSelect: 'none',
      boxSizing: 'border-box',
    },
    container: {
      background: 'white',
      borderRadius: '25px',
      boxShadow: '0 15px 40px rgba(0, 0, 0, 0.15)',
      padding: '2rem',
      width: '100%',
      maxWidth: '400px',
      textAlign: 'center',
    },
    h1: {
      color: '#0077b6',
      marginBottom: '1.5rem',
      fontSize: '1.8rem',
    },
    items: {
      display: 'flex',
      justifyContent: 'space-around',
      flexWrap: 'wrap',
      marginBottom: '1.5rem',
      gap: '1rem',
    },
    item: {
      background: '#caf0f8',
      borderRadius: '15px',
      padding: '1rem',
      flex: '1 0 30%',
      minWidth: '90px',
      boxShadow: 'inset 0 4px 8px rgba(0, 119, 182, 0.2)',
    },
    itemPrice: {
      fontSize: '1.4rem',
      fontWeight: 700,
      color: '#0077b6',
    },
    itemLabel: {
      marginTop: '0.5rem',
      fontSize: '1.1rem',
      color: '#023e8a',
      fontWeight: 700,
    },
    question: {
      fontSize: '1.2rem',
      marginBottom: '1rem',
      color: '#023e8a',
    },
    input: {
      fontFamily: "'Quicksand', sans-serif",
      fontSize: '1.2rem',
      padding: '0.5rem 1rem',
      width: '80%',
      maxWidth: '200px',
      borderRadius: '15px',
      border: '3px solid #0077b6',
      textAlign: 'center',
      outline: 'none',
    },
    button: {
      marginTop: '1.2rem',
      padding: '0.75rem 1.5rem',
      border: 'none',
      borderRadius: '25px',
      background: '#0077b6',
      color: 'white',
      fontSize: '1rem',
      cursor: 'pointer',
      boxShadow: '0 8px 20px rgba(0, 119, 182, 0.6)',
      marginRight: '10px',
    },
    feedback: {
      marginTop: '1.2rem',
      fontSize: '1.2rem',
      fontWeight: 700,
      minHeight: '38px',
    },
    correct: {
      color: '#2d6a4f',
    },
    incorrect: {
      color: '#b00020',
    },
  };

  return (
    <div style={styles.body}>
      <div style={styles.container} role="main" aria-label="Estimate the total cost game">
        <h2 style={styles.h1}>Estimate the Total</h2>

        <div style={styles.items} aria-live="polite" aria-label="Prices of items">
          {prices.map((price, index) => (
            <div key={index} style={styles.item}>
              <div style={styles.itemPrice}>${price.toFixed(2)}</div>
              <p style={styles.itemLabel}>Item {index + 1}</p>
            </div>
          ))}
        </div>

        <div style={styles.question}>
          Estimate the total cost by rounding to the nearest dollar.
        </div>

       <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
  <input
    type="number"
    ref={inputRef}
    style={styles.input}
    placeholder="Enter estimate"
    value={estimate}
    onChange={(e) => setEstimate(e.target.value)}
    onKeyDown={(e) => e.key === 'Enter' && checkEstimate()}
  />
</div>


        <div>
          {!showNew ? (
            <button style={styles.button} onClick={checkEstimate}>
              Check Estimate
            </button>
          ) : (
            <button style={styles.button} onClick={generatePrices}>
              Try Another
            </button>
          )}
        </div>

        <div
          style={{
            ...styles.feedback,
            ...(feedbackClass === 'correct'
              ? styles.correct
              : feedbackClass === 'incorrect'
              ? styles.incorrect
              : {}),
          }}
          role="alert"
          aria-live="assertive"
        >
          {feedback}
        </div>
      </div>
    </div>
  );
};

export default EstimateTotal;
